import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints'

export default async (machineIds, distributorId, proceed) => {
  const endpoint = `${apiEndpoints.distributors}/${distributorId}/machines`
  const URL = SERVER_PATH + endpoint
  const requestBody = {
    machineIds,
    proceed
  }
  return resolveRequest(axios.post(URL, requestBody, { withCredentials: true }))
}
